import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import { FLEET_CAMPAIGN } from './siteConfig';
import { trackEvent } from './analytics';

function FleetCampaignBanner() {
  const { pathname } = useLocation();

  if (!FLEET_CAMPAIGN.enabled || pathname === FLEET_CAMPAIGN.path) return null;

  return (
    <Box
      component='aside'
      aria-label='Program BYD Corporate Fleet'
      sx={{
        px: { xs: 2, md: 5 },
        py: { xs: 2.2, md: 2.5 },
        color: '#fff',
        background:
          'linear-gradient(100deg, #071b2b 0%, #0b3f4c 58%, #0d665e 100%)',
      }}
    >
      <Box
        sx={{
          maxWidth: 1180,
          mx: 'auto',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
          <BusinessCenterOutlinedIcon sx={{ mt: 0.2, color: '#71e1c2' }} />
          <Box>
            <Typography sx={{ fontWeight: 900, lineHeight: 1.25 }}>
              Butuh BYD untuk perusahaan?
            </Typography>
            <Typography sx={{ mt: 0.35, color: 'rgba(255,255,255,0.76)', fontSize: '0.9rem' }}>
              Konsultasikan kebutuhan Corporate & Fleet, jumlah unit, model,
              pembiayaan, dan lokasi pengiriman.
            </Typography>
          </Box>
        </Box>
        <Button
          component={RouterLink}
          to={FLEET_CAMPAIGN.path}
          onClick={() => trackEvent('fleet_banner_click', { source: pathname })}
          variant='contained'
          sx={{
            flexShrink: 0,
            px: 2.8,
            borderRadius: '999px',
            color: '#071b2b',
            backgroundColor: '#71e1c2',
            textTransform: 'none',
            fontWeight: 900,
            '&:hover': { backgroundColor: '#55ceb0' },
          }}
        >
          Info Fleet
        </Button>
      </Box>
    </Box>
  );
}

export default FleetCampaignBanner;

